import {
  FiActivity,
  FiBookOpen,
  FiClock,
  FiCoffee,
  FiHeart,
  FiMonitor,
  FiSun,
} from "react-icons/fi";

export const trustMarkers = [
  { spriteSet: "trust", spriteIndex: 0, value: "42+ Years", label: "Of global legacy" },
  { spriteSet: "trust", spriteIndex: 1, value: "Safe & nurturing", label: "Residential community" },
  { spriteSet: "trust", spriteIndex: 2, value: "Academic excellence", label: "With holistic development" },
  { spriteSet: "trust", spriteIndex: 3, value: "Sports, arts & nature", label: "And life skills" },
  { spriteSet: "trust", spriteIndex: 4, value: "A supportive home", label: "Away from home" },
];

export const whyBoarding = [
  {
    spriteSet: "why",
    spriteIndex: 0,
    title: "Healthy surroundings",
    text: "A green hill campus with space to learn, move and breathe.",
  },
  {
    spriteSet: "why",
    spriteIndex: 1,
    title: "A close-knit community",
    text: "Students learn independence while being supported by caring adults.",
  },
  {
    spriteSet: "why",
    spriteIndex: 2,
    title: "Learning with purpose",
    text: "Smart classrooms, support sessions, Robotics and the ATL lab enrich learning.",
  },
  {
    spriteSet: "why",
    spriteIndex: 3,
    title: "Whole-child development",
    text: "Academics, values, sport, creativity and well-being are part of everyday life.",
  },
];

export const boardingGallery = [
  {
    image: require("./Boarding House.webp"),
    title: "Boarding community",
    alt: "HGS Bhimtal boarding students on campus",
  },
  {
    image: require("./Hostel Rooms.webp"),
    title: "Comfortable rooms",
    alt: "Boarding room and study desks at HGS Bhimtal",
  },
  {
    image: require("../../image/boarding/2.jpg"),
    title: "Supported study",
    alt: "Boarding students studying together",
  },
  {
    image: require("./Dining.webp"),
    title: "Shared meals",
    alt: "Student dining facility at HGS Bhimtal",
  },
  {
    image: require("../../image/boarding/3.jpeg"),
    title: "Sport & recreation",
    alt: "Students playing basketball on the HGS Bhimtal campus",
  },
];

export const dailyRhythm = [
  { icon: FiSun, time: "6:30 AM", label: "Getting ready for school" },
  { icon: FiCoffee, time: "7:30 AM", label: "Breakfast" },
  { icon: FiBookOpen, time: "8:00 AM", label: "School starts" },
  { icon: FiCoffee, time: "11:20 AM", label: "Recess" },
  { icon: FiCoffee, time: "2:00 PM", label: "Lunch" },
  { icon: FiActivity, time: "4:00–5:00 PM", label: "Games time" },
  { icon: FiCoffee, time: "5:00 PM", label: "Tea time" },
  { icon: FiHeart, time: "5:50 PM", label: "Evening prayer" },
  { icon: FiMonitor, time: "6:50–7:15 PM", label: "Evening prep classes" },
  { icon: FiCoffee, time: "7:30 PM", label: "Dinner" },
  { icon: FiBookOpen, time: "8:00–10:00 PM", label: "Self-study" },
  { icon: FiClock, time: "10:00 PM", label: "Lights off" },
];

export const growthPillars = [
  { spriteSet: "growth", spriteIndex: 0, title: "Academics", text: "Strong foundations and individual support" },
  { spriteSet: "growth", spriteIndex: 1, title: "Life skills", text: "Responsibility, routines and independence" },
  { spriteSet: "growth", spriteIndex: 2, title: "Sports & arts", text: "Space to discover and nurture talent" },
  { spriteSet: "growth", spriteIndex: 3, title: "Well-being", text: "A caring environment where children feel known" },
  { spriteSet: "growth", spriteIndex: 4, title: "Leadership", text: "Teamwork, confidence and service" },
];

export const carePoints = [
  { spriteSet: "trust", spriteIndex: 4, label: "Experienced residential staff" },
  { spriteSet: "trust", spriteIndex: 1, label: "24×7 supervision" },
  { spriteSet: "careAcademic", spriteIndex: 4, label: "Medical facilities" },
  { spriteSet: "careAcademic", spriteIndex: 5, label: "Nutritious meals" },
  { spriteSet: "careAcademic", spriteIndex: 6, label: "Secure campus" },
  { spriteSet: "why", spriteIndex: 1, label: "Regular parent communication" },
];

export const academicPoints = [
  { spriteSet: "careAcademic", spriteIndex: 0, label: "Digital classrooms" },
  { spriteSet: "careAcademic", spriteIndex: 2, label: "Science & computer labs" },
  { spriteSet: "careAcademic", spriteIndex: 3, label: "Clubs & activities" },
  { spriteSet: "careAcademic", spriteIndex: 7, label: "Excursions & nature learning" },
];

export const admissionSteps = [
  { number: "01", title: "Enquire", text: "Share your child’s details with our admissions team." },
  { number: "02", title: "Connect", text: "Discuss availability, schooling needs and boarding options." },
  { number: "03", title: "Assessment", text: "Complete the applicable interaction or entrance process." },
  { number: "04", title: "Confirm", text: "Submit documents and fees within the communicated timeline." },
];

export const faqs = [
  {
    question: "How are admissions decided?",
    answer:
      "Admissions are subject to seat availability and the applicable interaction or entrance process. Entrance performance is considered from Grade IX onwards; Pre-Nursery and Nursery do not require a test or interview.",
  },
  {
    question: "Which documents are generally required?",
    answer:
      "Families should keep the birth certificate, previous school transfer certificate and report card, photographs, address and identity proofs, medical certificate, and applicable category certificates ready. Additional board documents may be needed for Classes X and XII.",
  },
  {
    question: "Can a transfer case be considered during the session?",
    answer:
      "Transfer cases from another state may be considered during the running session when a seat is available and the required school or board documents are produced.",
  },
  {
    question: "What support do boarders receive after class?",
    answer:
      "The residential programme combines guided study, extra academic support where needed, sport and recreation, balanced meals, supervised routines and access to trained staff.",
  },
  {
    question: "How can parents learn more before applying?",
    answer:
      "Submit the enquiry form, call the admissions team, or book a campus visit. A visit is the best way to see the classrooms, boarding spaces and daily environment first-hand.",
  },
  {
    question: "Are admissions open throughout the year?",
    answer:
      "Regular admissions depend on vacancies and normally close by 31 August. Transfer cases may be considered later, subject to availability and applicable rules.",
  },
];
